<template>
    <div class="container">
        <div class="row align-items-center">
            <div :class="'col-lg-6 col-12 text-center' +  (this.$i18n.locale === 'ar' ? 'text-lg-start' :  'text-lg-end')">
                <h2 class="title">   {{ $t('home.download_application.title') }}</h2>
                <p class="description">
                    {{ $t('home.download_application.description') }}
                </p>
                <div class="d-flex flex-row justify-content-center justify-content-lg-start gap-2">
                    <img class="stores_img" src="@/assets/images/home/application/appstore.png">
                    <img class="stores_img" src="@/assets/images/home/application/playstore.png">
                </div>
            </div>
            <div class="col-lg-6 col-12 text-center">
                <img class="apps_img img-fluid" src="@/assets/images/home/application/application.png">
            </div>
        </div>

    </div>
</template>

<style scoped>
.container {
    margin-top: 40px;
}
.title {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 20px;
}

.description {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
}
.stores_img {
    width: 190px;
    object-fit: cover;
}

.apps_img {
    width: 502px;
    height: 620px;
    object-fit: cover;
}
</style>